import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { View, Text, Image, TouchableOpacity, ScrollView } from 'react-native';
import { PnmacCard, PnmacParagraph, PnmacText, PnmacMediaQuery, PnmacMeta, PnmacPageBubble } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import BannerView from "../v2/BannerView";
import withPnmacTitle from "../withPnmacTitle";
var MakeADraw = /** @class */function (_super) {
  __extends(MakeADraw, _super);
  function MakeADraw(props) {
    var _this = _super.call(this, props) || this;
    _this.expRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  MakeADraw.prototype.render = function () {
    var _a = this.props,
      translations = _a.translations,
      layout = _a.layout,
      route = _a.route;
    var makeadraw = this.props.makeadraw;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a;
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        style: {
          padding: matches.small ? 0 : 10
        }
      }, makeadraw ? /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.MakeADrawPageTitle
      }) : /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.PendingDrawPageTitle
      }), /*#__PURE__*/React.createElement(View, {
        className: "row"
      }, ((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.helocFlag) && /*#__PURE__*/React.createElement(BannerView, {
        type: 'warning'
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.HelocVerbiage))));
    });
  };
  return MakeADraw;
}(Component);
export { MakeADraw };
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(MakeADraw, function (props) {
  return props.makeadraw ? props.translations.MakeADrawPageTitle : translations.PendingDrawPageTitle;
}));